/**
 * LP Scroll Reveal — shared GSAP animation utility
 * Usage: lpScrollReveal('#shopify-section-ID', '.selector1, .selector2', { stagger: 0.1 })
 **/
window.lpScrollReveal = function (sectionSelector, elSelectors, opts) {
  var section = document.querySelector(sectionSelector);
  if (!section) return;

  var els = section.querySelectorAll(elSelectors);
  if (!els.length) return;

  var options = opts || {};
  var stagger = options.stagger || 0.08;
  var duration = options.duration || 0.5;
  var start = options.start || 'top 88%';

  if (!window.gsap || !window.ScrollTrigger) {
    els.forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  els.forEach(function (el, i) {
    gsap.to(el, {
      opacity: 1,
      y: 0,
      x: 0,
      scale: 1,
      duration: duration,
      delay: i * stagger,
      ease: options.ease || 'power2.out',
      scrollTrigger: {
        trigger: el,
        start: start,
        toggleActions: 'play none none none',
        onEnter: (i === 0 && options.onEnter) ? options.onEnter : undefined
      }
    });
  });
};
